/* eslint no-console:0 */

import SingleLocationMap from 'components/SingleLocationMap/SingleLocationMap';
import WebpackerReact from '../webpacker_react/WebpackerReact';

WebpackerReact.setup({ SingleLocationMap });
